import axios from "axios";
import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { LuPlus } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useToast } from "../ToastContext";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

const DocumentList = ({ props }) => {
  const { documents, projectId, setProjects, project } = props;
  const showToast = useToast();
  const { Projects } = useAppLibs();

  const [docs, setDocs] = useState(documents);
  const [deletedDocs, setDeletedDocs] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const handleAddDocument = () => {
    setDocs([...docs, { name: "", url: "" }]);
  };

  const handleDeleteDocument = (index) => {
    if (!window.confirm("Are you sure?")) return;
    const docToDelete = docs[index];
    if (docToDelete._id) setDeletedDocs((prev) => [...prev, docToDelete._id]);
    setDocs(docs.filter((_, i) => i !== index));
  };

  const handleInputChange = (index, field, value) => {
    setDocs((prevDocs) =>
      prevDocs.map((doc, i) => (i === index ? { ...doc, [field]: value } : doc))
    );
  };

  const handleUpdateDocuments = async () => {
    if (!window.confirm("Are you sure?")) return;

    const updatedDocs = docs.filter((doc) => doc._id);
    const newDocs = docs.filter((doc) => !doc._id && doc.name && doc.url);
    const payload = { updatedDocs, newDocs, deletedDocs };

    try {
      const result = await Projects.updateDocuments(projectId, payload);
      if (result.success) {
        setEditMode(false);
        setProjects((prev) =>
          prev.map((p) => (p._id === result.data._id ? result.data : p))
        );
        showToast("Updated successfully", "success");
      } else {
        showToast(result.error, "warning");
      }
    } catch (error) {
      showToast("Error updating documents", "error");
    }
  };

  return (
    <table className="table bg-white animate-show shadow-inner p-4">
      <thead>
        <tr>
          <th className="w-[5%]">Sr.</th>
          <th className="w-[40%]">Document Name</th>
          <th className="w-[40%]">URL</th>
          <th className="w-[15%] text-right tracking-[1px] font-normal">
            <div className="flex gap-2 justify-end">
              {editMode ? (
                <>
                  <button
                    onClick={() => setEditMode(false)}
                    className="px-2 py-1 border uppercase border-orange-600 rounded-lg text-orange-700 hover:text-orange-800"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleUpdateDocuments}
                    className="px-2 py-1 border uppercase border-green-600 rounded-lg text-green-700 hover:text-green-800"
                  >
                    Save
                  </button>
                </>
              ) : (
                <button
                  onClick={() => setEditMode(true)}
                  className="px-2 py-1 flex gap-2 border self-end uppercase border-blue-600 rounded-lg text-blue-700 hover:text-blue-800"
                >
                  Edit <CiEdit />
                </button>
              )}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {docs.map((doc, i) => (
          <tr key={doc._id || i}>
            <td>{i + 1}</td>
            <td>
              <textarea
                value={doc.name}
                disabled={!editMode}
                onChange={(e) => handleInputChange(i, "name", e.target.value)}
                className={`text-xs h-auto w-full px-2 rounded-lg border focus:outline-none ${
                  editMode ? "bg-gray-50" : "bg-inherit border-none"
                }`}
              />
            </td>
            <td>
              {editMode ? (
                <input
                  type="url"
                  value={doc.url}
                  disabled={!editMode}
                  onChange={(e) => handleInputChange(i, "url", e.target.value)}
                  className={`min-h-9 ${
                    editMode
                      ? "w-full text-left input-sm px-2 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
                      : "bg-inherit w-[100%] border-none px-2 py-2 truncate"
                  }`}
                />
              ) : (
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500"
                >
                  {doc.url}
                </a>
              )}
            </td>
            <td className="text-right">
              {editMode && (
                <div className="flex gap-2 justify-end">
                  {i === docs.length - 1 && (
                    <button
                      onClick={handleAddDocument}
                      className="flex items-center justify-center w-6 h-6 rounded-full border border-green-700 bg-white shadow-md"
                    >
                      <LuPlus className="w-5 h-5 text-green-700" />
                    </button>
                  )}
                  <button
                    onClick={() => handleDeleteDocument(i)}
                    className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md"
                  >
                    <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                  </button>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DocumentList;
